import { SectionHeader } from '~analytics-components/section-header';
import type { AnalyticsSectionProps } from '~containers/analytics/overview-page/tabs';
import type { PageCoupon } from '~containers/analytics/overview-page/use-page-coupon';
import { KpiCardFromSpec } from '../kpis/kpi-card-from-spec';
import { CouponSelect } from '../kpis/coupon-select';
import type { KpiCardSpec } from '../kpis/card-spec';
import {
    PULSE_CARDS,
    DOWNLOADS_CARDS,
    ONBOARDING_CARDS,
    AGE_GATED_CARDS,
    COUPON_CARDS,
    COUPON_DETAIL_CARDS,
} from './cards';
import style from './style.module.scss';

export const AcquisitionSection = ({
    filter,
    pageCoupon,
}: Pick<AnalyticsSectionProps, 'filter' | 'pageCoupon'>) => {
    const renderCardWith = (
        spec: KpiCardSpec,
        index: number,
        cardCoupon?: PageCoupon
    ) => (
        <KpiCardFromSpec
            key={`${spec.source}-${spec.form}-${index}`}
            spec={spec}
            pageRange={filter.range}
            pageRegion={filter.provinces}
            compareEnabled={filter.compare}
            waveKey={filter.waveKey}
            pageCoupon={cardCoupon}
        />
    );
    const renderCard = (spec: KpiCardSpec, index: number) =>
        renderCardWith(spec, index);
    const renderCouponDetailCard = (spec: KpiCardSpec, index: number) =>
        renderCardWith(spec, index, pageCoupon);

    return (
        <div className={style.dashboard}>
            <section className={style.section}>
                <SectionHeader title="Pulse" />
                <div className={style.dashboard_grid}>
                    {PULSE_CARDS.map(renderCard)}
                </div>
            </section>
            <section className={style.section}>
                <SectionHeader title="Downloads" />
                <div className={style.dashboard_grid}>
                    {DOWNLOADS_CARDS.map(renderCard)}
                </div>
            </section>
            <section className={style.section}>
                <SectionHeader title="Detail" subtitle="trend & breakdown" />
                <div className={style.dashboard_grid}>
                    {ONBOARDING_CARDS.map(renderCard)}
                    {AGE_GATED_CARDS.map(renderCard)}
                </div>
            </section>
            <section className={style.section}>
                <SectionHeader
                    title="Coupons"
                    subtitle="issued against redeemed"
                />
                <div className={style.dashboard_grid}>
                    {COUPON_CARDS.map(renderCard)}
                </div>
            </section>
            <section className={style.section}>
                <SectionHeader
                    title="Coupon detail"
                    subtitle="one coupon at a time"
                    action={
                        <CouponSelect
                            coupons={pageCoupon.options}
                            value={pageCoupon.couponId}
                            onChange={pageCoupon.setCoupon}
                            error={pageCoupon.state.status === 'error'}
                            loading={pageCoupon.state.status === 'loading'}
                        />
                    }
                />
                {pageCoupon.state.status === 'empty' ? (
                    <p className={style.empty}>No active coupon to show.</p>
                ) : (
                    <div className={style.dashboard_grid}>
                        {COUPON_DETAIL_CARDS.map(renderCouponDetailCard)}
                    </div>
                )}
            </section>
        </div>
    );
};
